import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MfaType } from '@qc/shared/enums';

@Component({
    selector: 'qc-mfa-method-selector',
    standalone: true,
    imports: [CommonModule, ButtonModule],
    template: `
        <div>
            <h2 class="text-lg font-bold text-center mb-4">Choose Authentication Method</h2>
            <div class="flex flex-col gap-2">
                <p-button
                    type="button"
                    label="Authenticator App (TOTP)"
                    icon="pi pi-mobile"
                    styleClass="w-full"
                    (click)="selectMethod(MfaType.TOTP)"
                    size="large"
                />
                <p-button
                    type="button"
                    label="SMS Verification"
                    icon="pi pi-comment"
                    styleClass="w-full"
                    (click)="selectMethod(MfaType.SMS)"
                    size="large"
                />
            </div>
        </div>
    `,
})
export class MfaMethodSelectorComponent {
    @Output() methodSelected = new EventEmitter<string>();

    MfaType = MfaType;

    selectMethod(method: string): void {
        this.methodSelected.emit(method);
    }
}
